import React from 'react';

const WelcomeReport = ({ scoreAllList, userName, createdAt }) => {

  let getTotal = (score) => {
    let obj = {
      LABEL: "",
      TEXTCOLOR: "",
      CLASSCOLOR: "",
      TEXT: ""
    }
    if (score >= 151 && score <= 200) {
      obj["LABEL"] = 'High';
      obj["TEXTCOLOR"] = 'text-emerald-600';
      obj["COLORCLASS"] = 'bg-emerald-50 text-emerald-600 border-emerald-200'
      obj["TEXT"] = "High Engagement - Sustainable High Performance.Energy is renewable and well - managed."
    } else if (score >= 101 && score <= 150) {
      obj["LABEL"] = 'Moderate';
      obj["TEXTCOLOR"] = 'text-amber-500';
      obj["COLORCLASS"] = 'bg-amber-50 text-amber-500 border-amber-200'
      obj["TEXT"] = "Moderate Engagement - Inconsistent / Recoverable. Oscillation is irregular."
    } else if (score >= 0 && score <= 100) {
      obj["LABEL"] = 'Low';
      obj["TEXTCOLOR"] = 'text-rose-500';
      obj["COLORCLASS"] = 'bg-red-50 text-red-500 border-red-200'
      obj["TEXT"] = "Low Engagement - Depleted / At Risk. Expenditure is outrunning renewal."
    } else {
      obj["LABEL"] = 'N/A';
      obj["TEXTCOLOR"] = 'text-gray-400'
      obj["COLORCLASS"] = 'bg-gray-50 text-gray-500 border-gray-200'
    }
    return obj
  }

  const totalScore = scoreAllList.reduce(
    (sum, ele) => sum + (ele.score || 0),
    0
  )

  const getScoreStats = (scoreAllList = []) => {
    if (!scoreAllList.length) {
      return {
        max: 0,
        min: 0,
        diff: 0,
        maxName: "",
        minName: "",
        text: ""
      };
    }

    const maxItem = scoreAllList.reduce((a, b) =>
      Number(a.score) > Number(b.score) ? a : b
    );

    const minItem = scoreAllList.reduce((a, b) =>
      Number(a.score) < Number(b.score) ? a : b
    );

    const diff = Number(maxItem.score) - Number(minItem.score);

    return {
      max: Number(maxItem.score),
      min: Number(minItem.score),
      diff,
      maxName: maxItem.name,
      minName: minItem.name,
      text:
        diff >= 14
          ? `Imbalanced. ${minItem.name} is significantly weaker than ${maxItem.name}. Prioritize strengthening ${minItem.name} first, as it is likely limiting overall energy capacity and resilience.`
          : "Reasonably balanced. Energy is distributed evenly across dimensions, which lets each one reinforce the others. Continue to build capacity uniformly and guard against letting any single dimension slide under pressure."
    };
  };

  const stats = getScoreStats(scoreAllList);

  return (
    <div className="p-10 px-6 space-y-6 bg-white">
      <div className="px-12 space-y-6 page-break">
        <div className="flex items-center justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic">
          <h1 className="text-lg font-semibold">Energy Profile Report</h1>
          <p className="text-lg font-semibold">{userName} | {createdAt}</p>
        </div>

        {/* Title Section */}
        <div className="mt-6 mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">Dimension Scores</h1>
          <p className="text-base text-gray-600 mt-1">
            Auto-calculated as you complete the assessment - capacity across four dimensions.
          </p>
        </div>

        {/* Individual Dimensions */}
        <div className="space-y-6 pb-4">
          {scoreAllList.sort((b, a) => (a.score - b.score)).map((dim) => {
            const percentage = (dim.score / dim.maxScore) * 100;
            return (
              <div key={dim.name} className="space-y-2">
                <div className="flex justify-between items-end">
                  <span className="text-lg font-bold text-slate-800">{dim.name}</span>
                  <div className="flex items-center gap-4">
                    <span className="text-lg font-bold text-slate-800">
                      <span className={dim.scoreColor}>{dim.score + " "}</span>
                      <span className="text-gray-400 font-bold text-sm">{" / " + "" + dim.maxScore}</span>
                    </span>
                    <span className={`text-xs font-bold px-3 py-1 w-24 text-center rounded border tracking-wider ${dim.colorClass}`}>
                      {dim.status}
                    </span>
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="w-full h-5 bg-gray-100 rounded-sm overflow-hidden border border-gray-200">
                  <div className={`h-full ${dim.barColor}`} style={{ width: `${percentage}%` }} />
                </div>
                <p className="text-base text-gray-900 pt-0.5">{dim.text}</p>
              </div>
            );
          })}
        </div>

        {/* Total Engagement Section */}
        <div className="mt-8 pt-10 border-t border-gray-300 space-y-2">
          <div className="flex justify-between items-end">
            <span className="text-lg font-bold text-slate-800">Total Engagement</span>
            <div className="flex items-center gap-4">
              <span className="text-lg font-bold text-slate-800">
                <span className="text-blue-600">{totalScore + " "}</span>
                <span className="text-gray-400 font-bold text-sm">{" / " + " " + "200"}</span>
              </span>
              <span className={`text-xs font-bold px-3 py-1 w-24 text-center rounded border tracking-wider ${getTotal(totalScore)["COLORCLASS"]}`}>
                {getTotal(totalScore)["LABEL"]}
              </span>
            </div>
          </div>

          <div className="w-full h-5 bg-gray-100 rounded-sm overflow-hidden border border-gray-200">
            <div className="h-full bg-indigo-600" style={{ width: '55%' }} />
          </div>

          <p className="text-base font-medium text-slate-800 pt-1 tracking-wide">
            {getTotal(totalScore)["TEXT"]}
          </p>
        </div>


        {/* Balance Diagnostic Box */}
        <div className="pt-6">
          <h3 className="text-lg font-bold text-slate-800 uppercase tracking-wide mb-2">
            BALANCE DIAGNOSTIC
          </h3>
          <div className="p-5 bg-slate-50 border border-slate-200 rounded-md">
            <div className="text-base text-gray-900 font-bold mb-3">
              Strongest: {stats.maxName} ({stats.max})
              <span className="text-gray-400 font-normal mx-1">|</span>
              Weakest: {stats.minName} ({stats.min})
              <span className="text-gray-400 font-normal mx-1">|</span>
              Spread: ({stats.diff}) pts
            </div>

            <p className="text-base text-slate-600 leading-relaxed">
              {stats.text}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeReport;